import angular from 'angular';
import uiRouter from 'angular-ui-router';
import analyticsComponent from './analytics-marketing.component';

let analyticsModule = angular.module('app.containers.analytics-marketing', [
  uiRouter
])

.config(($stateProvider) => {
  "ngInject";
  $stateProvider
    .state('analyticsMarketing', {
      url: '/analytics-marketing',
      template: '<analytics-marketing></analytics-marketing>'
    });
})

.component('analyticsMarketing', analyticsComponent);

export default analyticsModule;



/** WEBPACK FOOTER **
 ** E:/JUGGLE_STREET/Juggle-Street-Deployment-All/JSBIGFOOTFRONTEND-BACKEND/admin-frontend/client/app/containers/analytics-marketing/analytics-marketing.js
 **/